import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import TermsAndConditionsSection from "../../Sections/TermsAndConditionsSection";

const TermsAndConditionsComponent = () => {
    return (
        <Dashboard sectionName={<TermsAndConditionsSection />}/>
    );
};

export default TermsAndConditionsComponent;
